/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    StudyPlanDTO,
    StudyPlanDTOFromJSON,
    StudyPlanDTOFromJSONTyped,
    StudyPlanDTOToJSON,
} from './StudyPlanDTO';

/**
 * 
 * @export
 * @interface StudyPlanDTOPagedResponse
 */
export interface StudyPlanDTOPagedResponse {
    /**
     * 
     * @type {number}
     * @memberof StudyPlanDTOPagedResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof StudyPlanDTOPagedResponse
     */
    pageSize?: number;
    /**
     * 
     * @type {number}
     * @memberof StudyPlanDTOPagedResponse
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<StudyPlanDTO>}
     * @memberof StudyPlanDTOPagedResponse
     */
    data?: Array<StudyPlanDTO> | null;
}

export function StudyPlanDTOPagedResponseFromJSON(json: any): StudyPlanDTOPagedResponse {
    return StudyPlanDTOPagedResponseFromJSONTyped(json, false);
}

export function StudyPlanDTOPagedResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): StudyPlanDTOPagedResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'pageSize': !exists(json, 'pageSize') ? undefined : json['pageSize'],
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'data': !exists(json, 'data') ? undefined : (json['data'] === null ? null : (json['data'] as Array<any>).map(StudyPlanDTOFromJSON)),
    };
}

export function StudyPlanDTOPagedResponseToJSON(value?: StudyPlanDTOPagedResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'pageSize': value.pageSize,
        'totalCount': value.totalCount,
        'data': value.data === undefined ? undefined : (value.data === null ? null : (value.data as Array<any>).map(StudyPlanDTOToJSON)),
    };
}

